/**
 * Shared defaults for ant-path rendering (Leaflet `leaflet-ant-path` + Mapbox two-line + dash animation).
 * Tune here so both {@link createLeafletMapProvider} and {@link createMapboxGlMapProvider} stay aligned.
 */

/** Fallbacks when `properties.map` omits a field (see {@link resolveAntPathStyle}). */
export const ANT_PATH_DEFAULTS = {
  lineColor: '#333333',
  lineWidth: 4,
  lineOpacity: 1,
  pulseColor: '#000000',
  /** Leaflet `leaflet-ant-path` delay (ms). Mapbox GL uses a fixed 50 ms step between dash keyframes. */
  cycleMs: 4000,
} as const

/** Passed to `leaflet-ant-path` (everything except coordinates). */
export const ANT_PATH_LEAFLET_PLUGIN = {
  hardwareAcceleration: true,
} as const

/**
 * Mapbox `line` layer layout for ant-path layers only.
 * `round` + `line-dasharray` produces visible bulges at vertices; Leaflet’s plugin does not.
 */
export const ANT_PATH_MAPBOX_LINE_LAYOUT = {
  'line-cap': 'butt',
  'line-join': 'miter',
} as const

/** Initial `line-dasharray` before the animation loop updates it. */
export const ANT_PATH_MAPBOX_INITIAL_DASH_ARRAY: [number, number, number] = [0, 4, 3]

